import React from 'react';
import { FlowBlockQR as QRBlockModel } from '@staffino/model';
import QRCode from 'react-qr-code';
import { Box, Paragraph } from '@staffino/primitive-controls';
import { ScrollAnchor } from './scroll';

type Props = {
  block: QRBlockModel;
};
const QRBlock = ({ block }: Props) => (
  <div>
    <ScrollAnchor id={block.id} />
    <Box width={1} maxWidth="30rem" m="1rem auto">
      {block.title && (
        <Paragraph
          flexDirection={'row' as const}
          justifyContent="center"
          alignItems="center"
          mb="0.625rem"
          fontSize="1.25rem"
          fontWeight="bold"
          color="headline"
          lineHeight="1.25"
        >
          {block.title}
        </Paragraph>
      )}
      <QRCode
        value={block.value || ''}
        style={{ margin: '0 auto' }}
        size={block.size || 128}
      />
    </Box>
  </div>
);

export default QRBlock;
